import { render, staticRenderFns } from "./UnpaidOrders.vue?vue&type=template&id=3b5a548e"
import script from "./UnpaidOrders.vue?vue&type=script&lang=js"
export * from "./UnpaidOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports